import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, FlexContainer, Loader, Tooltip, Typography } from '@rappi/rests-commons-front';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { useGlobal } from '../../../../../context/global/global.context';
import ShopIcon from '../../../../../icons/shop';
import { commercialProcessesService } from '../../../../../services/commercial-processes.service';
import { BankAccountCard } from '../../bank-account-card/bank-account-card';
import { BottomBar } from '../../bottom-bar/bottom-bar';
export const SelectBankAccount = ({ goNext, goBack, saveData, step, data, mode }) => {
    var _a;
    const { t } = useTranslation();
    const { state } = useGlobal();
    const { commercialProcessesById, country = 'CO' } = state;
    const { key } = step;
    const { bankAccountSelected } = data;
    const { data: bankList, isLoading } = useSWR(`bank-list/${country}`, () => commercialProcessesService.getAllBanks(country), {
        fallbackData: [],
    });
    const [selectedBankAccount, setSelectedBankAccount] = useState(bankAccountSelected !== null && bankAccountSelected !== void 0 ? bankAccountSelected : null);
    const handleNext = () => {
        saveData({
            bankAccountSelected: selectedBankAccount !== null && selectedBankAccount !== void 0 ? selectedBankAccount : undefined,
        });
        goNext();
    };
    return (_jsxs(FlexContainer, { direction: "column", gap: 24, children: [_jsx(Typography, { component: "headline", children: t(`commercialProcess.steps.${key}.title`) }), _jsx(Typography, { component: "body", children: t(`commercialProcess.steps.${key}.description`) }), _jsx(FlexContainer, { width: "100%", gap: 16, wrap: true, children: isLoading ? (_jsx(FlexContainer, { width: "100%", height: "220px", justifyContent: "center", alignItems: "center", children: _jsx(Loader, { fullscreen: false }) })) : ((_a = commercialProcessesById === null || commercialProcessesById === void 0 ? void 0 : commercialProcessesById.data) === null || _a === void 0 ? void 0 : _a.business.paymentReferences.map((p) => {
                    var _a;
                    const bank = bankList.find((b) => b.id === p.account.bankID);
                    const bankName = (_a = bank === null || bank === void 0 ? void 0 : bank.name) !== null && _a !== void 0 ? _a : t(`commercialProcess.steps.${key}.labels.bank`);
                    const accountNumber = `N° ${p.account.number}`;
                    return (_jsx(BankAccountCard, { type: p.account.accountType, bankName: bankName, number: accountNumber, owner: p.account.holderName, stores: p.paymentsStores.map((s) => s.storeID.toString()), selected: (selectedBankAccount === null || selectedBankAccount === void 0 ? void 0 : selectedBankAccount.id) === p.id, onSelect: () => {
                            if (mode === 'only-view')
                                return;
                            setSelectedBankAccount(p);
                        }, customRightData: _jsx(Tooltip, { isDark: true, text: p.paymentsStores.map((s) => s.storeID).join(', '), children: _jsx(Chip, { size: "s", customBgColor: "transparent", label: t('stores'), rightIcon: _jsx(ShopIcon, { size: 16 }), onClick: () => { } }) }) }, p.id));
                })) }), _jsx(BottomBar, { backButton: {
                    onClick: goBack,
                    text: t('back'),
                    variant: 'secondary',
                }, nextButton: {
                    onClick: handleNext,
                    text: t('next'),
                    variant: 'primary',
                    disabled: !selectedBankAccount && mode === 'new',
                } })] }));
};
